import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Gift, Tag, Ticket, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const usd = (c) => `$${((c || 0) / 100).toFixed(c % 100 === 0 ? 0 : 2)}`;

// === Logo Soup row ===
export function LogoSoupRow({ eventId }) {
  const [sponsors, setSponsors] = useState([]);
  useEffect(() => {
    let active = true;
    axios.get(`${API}/sponsorship/event/${eventId}/sponsors`).then(r => {
      if (active) setSponsors(r.data.sponsors || []);
    }).catch(() => {});
    return () => { active = false; };
  }, [eventId]);

  if (sponsors.length === 0) return null;
  return (
    <section className="border-t border-border py-8" data-testid="logo-soup-row">
      <p className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground text-center mb-4">Sponsored by</p>
      <div className="flex items-center justify-center gap-6 sm:gap-10 flex-wrap opacity-90">
        {sponsors.map(s => {
          const inner = s.logo_url ? (
            <img src={s.logo_url} alt={s.sponsor_name} className="h-10 sm:h-12 w-auto object-contain hover:opacity-100 opacity-70 transition" />
          ) : (
            <span className="text-sm text-muted-foreground hover:text-foreground transition">{s.sponsor_name}</span>
          );
          return s.website_url ? (
            <a key={s.sponsorship_id} href={s.website_url} target="_blank" rel="noopener noreferrer sponsored">{inner}</a>
          ) : (
            <span key={s.sponsorship_id}>{inner}</span>
          );
        })}
      </div>
    </section>
  );
}

// === Swag Bag badge ===
export function SwagBagBadge({ eventId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let active = true;
    axios.get(`${API}/swag-bag/event/${eventId}/badge`).then(r => {
      if (active) setData(r.data);
    }).catch(() => {});
    return () => { active = false; };
  }, [eventId]);

  if (!data || !data.has_swag_bag) return null;
  return (
    <Link to={`/swag-bag/${eventId}`} className="block group" data-testid="swag-bag-badge">
      <div className="rounded-2xl border border-emerald-500/30 bg-gradient-to-br from-emerald-500/10 via-indigo-500/10 to-fuchsia-500/10 p-5 hover:border-emerald-500/60 transition">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="text-[11px] uppercase tracking-[0.2em] text-emerald-400 font-semibold flex items-center gap-1.5"><Gift className="h-3.5 w-3.5" /> Digital Swag Bag</p>
            <p className="text-3xl font-bold mt-1">{usd(data.total_value_cents)} <span className="text-sm font-normal text-muted-foreground">in goodies</span></p>
            <div className="flex flex-wrap gap-3 mt-2 text-xs text-muted-foreground">
              <span className="flex items-center gap-1"><Tag className="h-3 w-3 text-emerald-400" /> {usd(data.discount_value_cents)} discounts</span>
              <span className="flex items-center gap-1"><Gift className="h-3 w-3 text-indigo-400" /> {usd(data.giveaway_value_cents)} giveaways</span>
              <span className="flex items-center gap-1"><Ticket className="h-3 w-3 text-amber-400" /> {data.sponsor_count} sponsors</span>
            </div>
          </div>
          <ArrowRight className="h-5 w-5 text-emerald-400 group-hover:translate-x-1 transition" />
        </div>
      </div>
    </Link>
  );
}
